<article>
  <header (click)="handleToggleAccordion()">
    <strong>Filtro</strong>
    <img
      class="accordion-img"
      [ngClass]="{ 'rotate-animation': !isOpen }"
      src="assets/icons/arrow.svg"
    />
  </header>

  <main [ngClass]="{ 'is-collapsed': !isOpen }">
    <div main class="main">
      <div class="grid-content">
        <app-input
          label="Nome"
          placeholder="Digite o nome para pesquisar"
          [control]="form.controls.name"
          [disabled]="false"
        ></app-input>
        <app-select-multi
          label="Status"
          placeholder="Selecione múltiplos Status"
          [multiControl]="form.controls.status"
          [options]="status"
          [selected]="selectedStatus"
          property="Type"
          [disabled]="false"
          [multi]="true"
        ></app-select-multi>
        <div class="period">
          <app-input
            label="Data de Criação"
            placeholder="De"
            [control]="form.controls.initialDate"
            [disabled]="false"
            [type]="InputTypeEnum.date"
          ></app-input>
          <app-input
            label=""
            placeholder="Até"
            [control]="form.controls.finalDate"
            [disabled]="false"
            [type]="InputTypeEnum.date"
          ></app-input>
        </div>

        <app-select-multi
          label="Clientes"
          placeholder="Selecione múltiplos clientes"
          [multiControl]="form.controls.clients"
          [options]="clientOptions"
          [selected]="selectedClients"
          [multi]="true"
          [disabled]="loadingClients"
          [loading]="loadingClients"
          [isSearch]="true"
          [loadingSearch]="loadingSearchClients"
          [isDinamicSearch]="true"
          (searchValueEmmiter)="getClients($event)"
          [isPaged]="true"
          [loadingPage]="loadingMoreClients"
          (scrollEndedEmmiter)="getMoreClients()"
        >
        </app-select-multi>
      </div>
    </div>

    <hr />

    <div footer class="footer">
      <app-secondary-button
        (click)="clear()"
        label="Limpar"
        [color]="ButtonColorEnum.warning"
        [icon]="'assets/icons/trash.svg'"
        [enabled]="true"
        [widthFull]="true"
      >
      </app-secondary-button>
      <app-primary-button
        label="Filtrar"
        [color]="ButtonColorEnum.common"
        [loading]="isLoading"
        (clickFunc)="search()"
        [enabled]="!loadingClients"
      ></app-primary-button>
    </div>
  </main>
</article>
